import i18next from 'i18next'
import Backend from 'i18next-http-backend'
import {initReactI18next} from 'react-i18next'

i18next
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: 'en-US',
    fallbackLng: false,
    load: 'currentOnly',
    preload: [],
    ns: [],
    defaultNS: false,
    partialBundledLanguages: true,
    interpolation: {
      escapeValue: false, // not needed for react!!
    },
    react: {
      useSuspense: false,
    },
  })

export default i18next
